<template>
  <div class="container mt40 w100">
    <div class="common-detail-content">
      <!-- 上半部 -->
      <div class="content-box">
        <div class="banner-box">
          <div class="left">
            <div class="banner">
              <el-carousel ref="carousel" :interval="5000" arrow="always" height="356px" :initial-index="bannerIdx">
                <el-carousel-item v-for="(item,index) in banners" :key="index">
                  <img :style="{width: '100%', height: '100%'}" :src="item" alt="">
                </el-carousel-item>
              </el-carousel>
            </div>
            <div class="banner-label">
              <div :class="['banner-label-item', bannerActiveIdx == 0 ? 'active' : '']" @click="bannerChange(0)">全部图片({{info.bannerTotalNum || 0}})</div>
              <template v-if="info.bannerList.length > 0">
                <div :class="['banner-label-item', bannerActiveIdx === index + 1 ? 'active' : '']" v-for="(item, index) in info.bannerList" :key="index" @click="bannerChange(index + 1)">{{item.title}}({{item.imgList.length}})</div>
              </template>
            </div>
          </div>

          <div class="right">
            <div class="title">
              <div class="title-name">{{info.name}}</div>
            </div>
            <div class="score">
              <div class="score-start">
                <div class="star-box">
                  <div class="star-icon1"></div>
                  <div :style="{width: info.avgReviewScore <= 0 ? '0':(17 * (info.avgReviewScore - 0) + 'px')}" class="star-icon2"></div>
                </div>
                <div class="star-box">
                  <div class="star-icon1"></div>
                  <div :style="{width: info.avgReviewScore <= 1 ? '0':(17 * (info.avgReviewScore - 1) + 'px')}" class="star-icon2"></div>
                </div>
                <div class="star-box">
                  <div class="star-icon1"></div>
                  <div :style="{width: info.avgReviewScore <= 2 ? '0':(17 * (info.avgReviewScore - 2) + 'px')}" class="star-icon2"></div>
                </div>
                <div class="star-box">
                  <div class="star-icon1"></div>
                  <div :style="{width: info.avgReviewScore <= 3 ? '0':(17 * (info.avgReviewScore - 3) + 'px')}" class="star-icon2"></div>
                </div>
                <div class="star-box">
                  <div class="star-icon1"></div>
                  <div :style="{width: info.avgReviewScore <= 4 ? '0':(17 * (info.avgReviewScore - 4) + 'px')}" class="star-icon2"></div>
                </div>
              </div>
              <div class="score-grade">{{info.avgReviewScore == null ? '暂无评' : info.avgReviewScore}}分</div>
              <div class="score-number">{{info.reviewTimes || 0}}</div>
              <div class="score-text">人评论</div>
            </div>
            <div class="contactway">
              <div class="contactway-item">
                <div class="label">餐厅地址:</div>
                <div class="text">
                  {{info.addressDetails}}
                </div>
              </div>
              <div class="contactway-item">
                <div class="label">营业时间:</div>
                <div class="text">
                  {{info.openingTime}}
                </div>
              </div>
              <div class="contactway-item">
                <div class="label">联系方式:</div>
                <div class="text">
                  {{info.phone ? info.phone : '暂无联系方式'}}
                </div>
              </div>
              <div class="contactway-item">
                <div class="label">餐厅简介:</div>
                <div class="text">
                  <p>{{info.synopsis}}</p>
                </div>
              </div>
              <div class="contactway-item">
                <div class="label">人均消费:</div>
                <div class="price">
                  ￥{{info.consumptionPerPerson || 0}}
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="flat-pattern">
          <div class="left-arrows" :class="{disabled: banners.length <= 6 || moveLeft === 0}" @click="handleBannerPrev"></div>
          <div class="img-list">
            <div class="img-box" :style="{left: -moveLeft + 'px'}">
              <div class="img-item" v-for="(item,index) in banners" :key="index">
                <img :src="item" alt="" @click="bannerIdxSel(index)">
              </div>
            </div>
          </div>
          <div class="right-arrows" :class="{disabled: banners.length <= 6 || moveLeft === (banners.length - 6) * imgHeight}" @click="handleBannerNext"></div>
        </div>
      </div>

      <!-- 中间 -->
      <div class="content-box">
        <div class="body-nav">
          <navTab :navList="navList" :tabPage="tabPage" :showDivider="true" @handleTabPage="handleTabPage"/>
          <div v-if="proList.length > 0" class="body-list body-list2">
            <div class="body-item" v-for="(item, index) in proList" :key="index">
              <div class="left">
                <div class="left-img"><img :src="item.mainPic" alt=""></div>
                <div class="left-right">
                  <div class="right-title nowrap">{{item.goodsName || item.name}}</div>
                  <div class="right-solenum nowrap">剩余库存：{{item.surplusStock===-1?'不限':item.surplusStock?item.surplusStock:0}}</div>
                  <div class="rules mt10 nowrap" v-if="item.ruleInfoOptionList && item.ruleInfoOptionList.length > 0">
                    <template v-for="(stem,sidx) in item.ruleInfoOptionList">
                      <span v-if="stem.optionValue && stem.ruleCode !== 'PROMPT_INFO'" :key="sidx">{{stem.optionValue}}</span>
                    </template>
                  </div>
                  <!-- <div class="right-rule" @click="reservationNotesVisible = true">使用规则 ></div>
                  <el-dialog
                      title=""
                      :visible.sync="reservationNotesVisible"
                      width="40%"
                      :show-close="true">
                        <div class="rules" v-if="item.ruleInfoOptionList && item.ruleInfoOptionList.length > 0">
                          <template v-for="(stem,sidx) in item.ruleInfoOptionList">
                            <span v-if="stem.optionValue && stem.ruleCode !== 'PROMPT_INFO'" :key="sidx">{{stem.optionValue}}</span>
                          </template>
                        </div>
                    </el-dialog> -->
                </div>
              </div>
              <div class="right">
                <div class="rigth-box">
                  <span class="sale-price"><span class="font-sm">¥</span>{{item.salePrice || 0}}</span>
                  <span v-if="item.goodsPrice != null" class="goods-price"><span class="font-sm">¥</span>{{item.goodsPrice || 0}}</span>
                </div>
                <div class="right-btn pointer" v-if="item.surplusStock > 0 || item.surplusStock === -1" @click="handleToBook(item.id)">立即预订</div>
                <div class="right-btn pointer disabled" v-else>已售罄</div>
              </div>
            </div>
          </div>
          <div class="no-data" v-else>暂无数据</div>
        </div>
      </div>
      <!-- 餐厅信息 -->
      <div class="content-box">
        <div class="information">
          <div class="titile">餐厅信息</div>

          <div class="label-box">
            <div>餐厅介绍</div>
            <div class="policy" v-html="getRichContent(info.introduce)"></div>
          </div>

        </div>
      </div>
      <!-- 评论 -->
      <div class="content-box">
        <div class="information">
          <div class="titile">网友点评({{totalCount}})</div>

          <div class="comment-box">
            <div class="comment-list" v-for="item in comlist" :key="item.id">
              <div class="flex floor">
                <img :src="item.avatarUrl"/>
                <div class="com-name">
                  <div class="name">{{item.crtName}}</div>
                  <el-rate v-model="item.score" disabled show-score text-color="#FF0000" :score-template="item.score+'分'"/>
                </div>
                <div class="com-date">{{item.crtTime}}</div>
              </div>
              <div class="com-content">
                {{item.content}}
                <div class="img-comm">
                    <img v-for="(imgs,index) in item.pictures" :key="index" :src="imgs.url"/>
                </div>
                <div class="reply" v-if="item.replyContent">
                  <span class="lare">商家回复:</span>
                  {{item.replyContent}}
                </div>
              </div>
            </div>

          </div>
          <div class="pagination-self" v-if="comlist.length > 0">
            <el-pagination
              background
              prev-text="上一页"
              next-text="下一页"
              layout="prev, pager, next"
              @current-change="handleCurrentChange"
              :total="totalCount"
              >
            </el-pagination>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import NavTab from '@/components/navTab'
import { loadIndustryInfo } from '@/api/home'
import { loadSaleList, orderReview } from '@/api/food/foodDetail'
import { richTextWrap } from '@/common/js/utils'
import { queryDetailMixin } from '@/mixins/queryDetailMixin'
import { config } from '@/constant/config'

export default {
  mixins: [queryDetailMixin],
  name: 'foodDetail',
  data () {
    return {
      moduleType: 'FOOD',
      reservationNotesVisible: false,
      navList: ['堂食套餐'],
      proList: [],
      mealList: [],
      totalCount: 0,
      couponList: [],
      comlist: [],
      page: 1,
      limit: 10
    }
  },
  components: {
    'navTab': NavTab
  },
  created () {
    this.orderReview()
  },
  methods: {
    // 富文本处理
    getRichContent (content) {
      if (content && typeof (content) === 'string') {
        const regexPre = new RegExp('pre>', 'g')
        content = content.replace(regexPre, 'div>')
      }
      return content
    },
    orderReview () {
      const data = {
        page: this.page,
        limit: this.limit,
        moduleType: 'FOOD',
        merchId: config.MERCHID,
        tenantId: config.TENANTID,
        merchIndustryId: this.id
      }
      orderReview(data).then(res => {
        if (res.code === 0) {
          res.data.list.forEach(item => {
            item.pictures = JSON.parse(item.pictures)
          })
          this.comlist = res.data.list
          this.totalCount = res.data.totalCount
        }
      })
    },
    // 翻页
    handleCurrentChange (val) {
      this.page = val
      this.orderReview()
    },
    // tab切换
    handleTabPage (index) {
      this.tabPage = index
      if (index === 0) {
        this.proList = this.mealList
      } else {
        this.proList = this.couponList
      }
    },
    handleToBook (id) {
      this.$router.push({ path: 'foodBooking', query: { merchIndustryId: this.id, id } })
    },
    loadInfo () {
      loadIndustryInfo(this.id).then(res => {
        if (res.code === 0) {
          const obj = res.data
          obj.reservationNotes = richTextWrap(obj.reservationNotes) || '暂无'
          this.loadIndustryOrMerchData(obj)
        }
      })
    },
    loadProducts () {
      const data = {
        tenantId: config.TENANTID,
        merchId: config.MERCHID,
        merchIndustryId: this.id
      }
      loadSaleList(data).then(res => {
        if (!res.data) {
          return
        }
        res.data.forEach(item => {
          const pictures = JSON.parse(item.goodsPicture)
          const obj = pictures.find(pic => pic.index === 1)
          item.mainPic = (obj && obj.url) || null
          item.usageRule = richTextWrap(item.usageRule) || '暂无'
          if (item.type === 'MENU') {
            this.mealList.push(item)
          } else if (item.type === 'COUPON') {
            this.couponList.push(item)
          }
        })
        this.proList = this.mealList
        // if (this.mealList.length > 0) {
        //   this.proList = this.mealList
        // } else if (this.couponList.length > 0) {
        //   this.proList = this.couponList
        //   this.tabPage = 1
        // }
      })
    }
  }
}
</script>

<style scoped lang='scss'>
.top {
  height: 166px;
  width: 100%;
}
.saled{
  font-size: 16px;
  line-height: 24px;
  font-weight: 400;
  color: #F0BD5D;
  margin-bottom: 36px;
  margin-top: 10px;
}
.qrcode-img{
  width: 136px;
  height: 136px;
  img{
    width: 136px;
    height: 136px;
  }
}

</style>
